import { Injectable } from '@angular/core';

import { CustomField } from 'src/models';

import { GenericObjectsService } from './generic-objects.service';

interface GetConversationsWithFieldParams {
  limit?: number;
  cursor?: string;
  order?: string[];
  descending?: boolean;
}

interface FieldContext {
  conversationId?: string;
  // Optional override fields for cases where conversation isn't available yet
  customerId?: string;
  projectId?: string;
  ticketTypeId?: string;
  [key: string]: any;
}

interface CustomFieldOptionsParams {
  query?: string;
  context?: FieldContext;
  contextOverrides?: any;
}

interface CustomFieldOption {
  label: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class CustomFieldsService extends GenericObjectsService<CustomField> {
  protected baseUrl = '/custom-fields';

  getConversationsWithField(customFieldId: string, params?: GetConversationsWithFieldParams) {
    return this.apiService.postPromise(`${this.baseUrl}/${customFieldId}/conversations`, params || {});
  }

  /**
   * Get options for a custom field using the new consolidated endpoint.
   * This handles all field types (static, external select, conditional) through a single API call.
   *
   * @param customFieldId - The ID of the custom field to get options for
   * @param params - Parameters for getting field options
   * @returns Promise<CustomFieldOption[]> - Array of options with label and value
   */
  getOptions(customFieldId: string, params: CustomFieldOptionsParams): Promise<CustomFieldOption[]> {
    const { ...requestBody } = params;

    return this.apiService.postPromise(`${this.baseUrl}/${customFieldId}/options`, requestBody);
  }
}
